import { logger } from '../../helpers/logger';

export function editUrl(WS_URL) {
	const hostname = window.location.hostname;
	if (WS_URL.includes('orbitalgaming.com')) {
		console.clear();
		logger.isEnabled = false;
	}

	if (hostname === 'localhost') {
		WS_URL = 'wss://dev.orbitalgaming.io/wsbridge/v1/game/orbital.stellar';
	} else if (WS_URL === '{{SERVER_WS_URL}}') {
		WS_URL = `wss://${hostname}/wsbridge/v1/game/orbital.stellar`;
	}
	// WS_URL = 'wss://dev.orbitalgaming.io/wsbridge/v1/game/orbital.stellar'
	// WS_URL = "ws://192.168.88.68:10045/wsbridge/v1/game/orbital.stellar"
	return WS_URL;
}
